import React, { useEffect, useRef } from "react";
import Container from "../../UI/Container/Container";
import classes from "./Message.module.css";
import { gsap } from "gsap";
import { ScrollTrigger } from "gsap/ScrollTrigger";

const Message = (props) => {
  gsap.registerPlugin(ScrollTrigger);

  const textRef = useRef(null);

  useEffect(() => {
    const timeline = gsap.timeline({
      scrollTrigger: {
        trigger: textRef.current,
        start: "top 50%",
      },
    });

    timeline.to(textRef.current, { opacity: 1, duration: 1, ease: "sine.out" });
  });

  return (
    <div className={classes.Message}>
      <Container>
        <p ref={textRef}>
        Our founder, Benjamin Rush, was a revolutionary thinker in a lot of ways, and
we are forever grateful that he wanted his college to be connected to a town.
He knew even back in 1783 that this would matter. That being connected to the
community, being within walking distance of the town square, the courthouse,
shops, businesses and schools, was important for the education of students.
        </p>
      </Container>
    </div>
  );
};

export default Message;
